import React, { Component } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import moment from 'moment';
import { firestore } from '../../config/firebase';
import { createCurrency } from '../../store/actions/currencyActions';
import { createUser } from '../../store/actions/userActions';
import CurrencyRateChange from './CurrencyRateChange';
import usaFlag from './assets/usa.svg';
import uzbFlag from './assets/uzb.svg';
import lang from './lang';
import Swal from 'sweetalert2';
import './Currency.css';

const API_KEY = "7033825bfe31262791b5"; //https://www.currencyconverterapi.com/docs
const CURRENCY_TYPE = "USD_UZS,RUB_UZS"; //https://www.currencyconverterapi.com/docs


class Currency extends Component {
    state = {
        usdAmount: 1,
        uzsAmount: 8400,
        USD_UZS: 0,
        RUB_UZS: 0,
        custom: false,
        active: false,
        data: {}
    }

    componentDidMount() {
        if (this.props.currency.custom && this.props.user.uzsAmount) {
            this.setState({ ...this.props.currency });
        } else {
            axios.get(`//free.currconv.com/api/v7/convert?q=${CURRENCY_TYPE}&compact=ultra&apiKey=${API_KEY}`)
                .then(res => {
                    firestore
                        .doc('users/' + this.props.user.id)
                        .update({ uzsAmount: res.data.USD_UZS })
                        .then(doc => {
                            console.log('Updated user');
                            return this.setState({ ...res.data, active: false }, () => {
                                return this.props.createCurrency(this.state);
                            });
                        });


                })
                .catch(err => console.log(err))
        }

        // Get rate change since last week
        const today = moment().format('YYYY-MM-DD');
        const lastWeek = moment().subtract(6, 'days').format('YYYY-MM-DD');

        axios.get(`https://free.currconv.com/api/v7/convert?apiKey=${API_KEY}&q=${CURRENCY_TYPE}&compact=ultra&date=${lastWeek}&endDate=${today}`)
            .then(({ data }) => {
                return this.setState({ data: { today, lastWeek, ...data } });
            })
            .catch(err => console.log(err))

    }

    customPriceHandler = (e) => {
        this.setState({ custom: true, uzsAmount: parseFloat(e.target.value || this.state.USD_UZS) });

    }

    switchHandler = () => {
        return this.setState(prevState => ({ custom: !prevState.custom, uzsAmount: prevState.custom ? prevState.USD_UZS : prevState.uzsAmount }), () => {
            this.props.createCurrency(this.state);
            firestore
                .doc('users/' + this.props.user.id)
                .update({ uzsAmount: this.state.uzsAmount })
                .then(doc => {
                    this.props.updateUser({ ...this.props.user, uzsAmount: this.state.uzsAmount });
                    console.log('Uzd is updated');
                    // Swal.fire({
                    //     type: 'success',
                    //     text: 'Currency rate saved successfully'
                    // })
                });
        });
    }

    manualPriceUpdateHandler = () => {
        this.props.createCurrency(this.state);
        firestore
            .doc('users/' + this.props.user.id)
            .update({ uzsAmount: this.state.uzsAmount })
            .then(doc => {
                this.props.updateUser({ ...this.props.user, uzsAmount: this.state.uzsAmount });
                console.log('Uzd is updated');
                Swal.fire({
                    type: 'success',
                    text: 'Currency rate saved successfully'
                })
            });
    }

    render() {
        const { title, rate, date, btn } = lang[this.props.user.lang || "en"];
        return (
            <div id="currency-page">
                <h3 className="text-center">{title}</h3>

                <div className="border border-5 rounded bg-white p-3 pb-5">
                    <div className="text-right mt-1 mb-3">
                        <div className="switcher">
                            <div className="custom-control custom-switch">
                                <input
                                    type="checkbox"
                                    className="custom-control-input"
                                    checked={this.state.custom}
                                    readOnly
                                />
                                <label
                                    onClick={this.switchHandler}
                                    className="custom-control-label"
                                >{rate}</label>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-5 my-2 my-md-0">
                            <div className="input-group input-group-lg">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <img src={usaFlag} width="30" alt="USD flag" /> <small className="ml-1">USD</small>
                                    </span>
                                </div>
                                <input
                                    type="text"
                                    className="form-control form-control-lg"
                                    defaultValue={this.state.usdAmount}
                                    name="uzdAmount"
                                    onChange={(e) => this.setState({ usdAmount: e.target.value })}
                                />
                            </div>
                        </div>
                        <div className="col-md-5 my-2 my-md-0">
                            <div className="input-group input-group-lg">
                                <div className="input-group-prepend">
                                    <span className="input-group-text">
                                        <img src={uzbFlag} width="30" alt="USD flag" /> <small className="ml-1">UZS</small>
                                    </span>
                                </div>
                                <input
                                    type="number"
                                    className="form-control form-control-lg"
                                    value={Math.round(this.state.custom === true ? this.state.uzsAmount : this.state.USD_UZS)}
                                    name="uzsAmount"
                                    onChange={(e) => this.customPriceHandler(e)}
                                />
                            </div>
                        </div>
                        <div className="col-md-2 my-2 my-md-0">
                            <button className="btn btn-lg btn-success w-100" onClick={this.manualPriceUpdateHandler}>{btn}</button>
                        </div>
                    </div>
                </div>
                <CurrencyRateChange data={this.state.data} date={date} />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        currency: state.currency,
        user: state.user
    }
}
const mapDispatchToProps = dispatch => {
    return {
        createCurrency: (data) => dispatch(createCurrency(data)),
        updateUser: (data) => dispatch(createUser(data))
    }
}
export default connect(mapStateToProps, mapDispatchToProps)(Currency);